/** ***********
*
* <kpi-cycle-time-monitoring.component.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { KpiFamily } from 'src/app/services/kpi.service';
import { ChartClickEvent } from '../../shared/kpi/chart.base';

@Component({
    selector: 'app-kpi-cycle-time-monitoring',
    templateUrl: './kpi-cycle-time-monitoring.component.html',
    styleUrls: ['./kpi-cycle-time-monitoring.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KpiCycleTimeMonitoringComponent {

  @Input() public dataKPIcycle: KpiFamily;
  @Input() public loaded: boolean;

  public indexAssetClicked: number;
  public indexCycleClicked: number;
  public trend: {
    indexAssetClicked?: number;
    indexCycleClicked?: number;
  } = {};
  public zoneLevel2 = false;

  constructor(
    private _cd: ChangeDetectorRef,
  ) { }

  public onAssetsChartClicked({ item }: ChartClickEvent): void {
    if (item[0] !== undefined) {
      this.indexAssetClicked = item[0].index;
      this._cd.detectChanges();
    }
  }

  public onCyclesChartClicked({ item }: ChartClickEvent): void {
    if (item[0] !== undefined) {
      this.indexCycleClicked = item[0].index;
      this._cd.detectChanges();
    }
  }

  public onTrendFamilyChartClick({ others }: ChartClickEvent): void {
    this.trend.indexAssetClicked = others.assetIndex;
    this.trend.indexCycleClicked = others.cycleIndex;
    this._cd.detectChanges();
  }

}
